import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as fromNFCActions from '../actions/nfc.actions';
import * as fromNFCReducer from '../reducers/nfc.reducer';
import * as fromNFCSelector from '../selectors/nfc.selector';
import { NFCModel } from '../../models/nfc.model';

@Injectable()
export class NFCFacade {

    constructor(private store: Store<fromNFCReducer.NFCState>) { }

    get isLoading$(): Observable<boolean> {
        return this.store.select(fromNFCSelector.getIsLoading);
    }
    get succeeded$(): Observable<any> {
        return this.store.select(fromNFCSelector.getSucceeded);
    }
    get hasError$(): Observable<boolean> {
        return this.store.select(fromNFCSelector.getHasError).pipe(filter((x) => x));
    }
    get error$(): Observable<any> {
        return this.store
            .select(fromNFCSelector.getErrorMessage);
    }
    get nfcDevices$(): Observable<NFCModel[]> {
        return this.store.select(fromNFCSelector.getNFCDevices).pipe(filter((x) => !!x));
    }

    loadNFCDevices() {
        this.store.dispatch(fromNFCActions.loadNFCDevicesBegin());
    }

    activateNFCDevice(payload: FormData) {
        this.store.dispatch(fromNFCActions.createNFCDeviceBegin({payload: payload}));
    }

    updateNFCDevice(payload: FormData) {
        this.store.dispatch(fromNFCActions.updateNFCDeviceBegin({payload: payload}));
    }

}
